import { Col, Row, TabControl, Text } from 'components';
import { useState } from 'react';
import { Header } from 'screens/Admin/components';
import { AllShoutouts, CtaPresets } from './components';

const TABS = ['All', 'CTA Presets'];

const Shoutouts = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <Col noFlex wid="100%" ht="100vh" start>
      <Header>
        <Row center>
          <Text h3>Shoutouts</Text>
        </Row>
      </Header>

      <Col start noFlex wid="100%" className="mt-[54px] h-[calc(100vh-54px)] overflow-y-auto">
        <TabControl options={TABS} selectedIdx={selectedTab} handleSelect={setSelectedTab} />

        {selectedTab === 0 && <AllShoutouts />}
        {selectedTab === 1 && <CtaPresets />}
      </Col>
    </Col>
  );
};

export default Shoutouts;
